import { ConnectionType } from '../../../../shared/connection-type/connection-type';
import { ConnectionModel } from '../../connection.model';

const ConnectionTypeCell: React.FC<{ connection: ConnectionModel }> = ({ connection }) => {
    return <ConnectionType circuitType={connection.type} />;
};
export default ConnectionTypeCell;